export default {
  title: 'Favorite',
  button: {
    create: 'Create',
    copy: 'Copy',
  },
};
